export function socialNetwork() {
    let $win = $(window);
    let positionAbsoluteClass = "position-absolute";
    let positionStickyClass = "position-sticky";

    if ($win.width() >= 1200) {

        $win.on("load resize orientationchange scroll", function () {
            let targetBlock = $(".social-networks");

            let curSection = targetBlock.closest(".container").parent();
            let togglePositionClass = function () {
                let offsetTop = $(curSection).offset().top + ($(curSection).innerHeight() - $(curSection).height());
                let winScrollTop = $win.scrollTop();
                let bottomPosition = offsetTop + $(curSection).height() - $(targetBlock).height();
                let isScrollOutsideTheBottomPosition = bottomPosition < winScrollTop;
                let isRemoveStickyClass = isScrollOutsideTheBottomPosition || (offsetTop > winScrollTop);

                if (isRemoveStickyClass) {
                    targetBlock.css({
                        "top": "",
                    });
                    targetBlock.removeClass(positionStickyClass);

                    if (isScrollOutsideTheBottomPosition) {
                        targetBlock.addClass(positionAbsoluteClass);
                    } else {
                        targetBlock.removeClass(positionAbsoluteClass);
                    }
                } else {
                    targetBlock.css({
                        "top": "0",
                    });
                    targetBlock.removeClass(positionAbsoluteClass);
                    targetBlock.addClass(positionStickyClass);
                }
            };

            togglePositionClass();
        });
    }
}


// WEBPACK FOOTER //
// ./assets/js/modules/socialNetwork.js